/**
 * Base controller class implementing the Controller interface skeleton.
 * Concrete controllers extend this and implement compute().
 */

import type { Environment, RocketState, ControlAction, Controller } from "../types";

export abstract class BaseController implements Controller {
  abstract readonly name: string;

  reset(): void {
    // Default: no state to reset. Override if the controller has internal state.
  }

  abstract compute(
    state: RocketState,
    env: Environment,
    dt: number
  ): ControlAction;
}
